import MainLayout from 'components/layout/Main';

const Home: React.FunctionComponent = function () {
  return (
    <MainLayout>
      <div>Home</div>
    </MainLayout>
  );
};

export default Home;
